import getAppName from './getAppName';
const getIsCmsOnboardingRoute = () => {
  return getAppName() === 'cms-onboarding-ui';
};
export default getIsCmsOnboardingRoute;